// extracted by mini-css-extract-plugin
export default {"clock":"Clock_clock__9wUSL","landscape":"Clock_landscape__PQO6J","timer":"Clock_timer__Dr4Ht","separator":"Clock_separator__JLR3O"};